import React, {useRef, useState} from 'react'
import {
    InfoModalHeader,
    MobileBackground,
    ModalBody,
    ModalContent,
    ModalFooter,
    ProfileModalsEditMenu,
} from '../../components/ui/Modal';
import {Body1Pointer, Body1PointerLink, Title} from "../../components/Font";
import {BackArrow, Dots, EditPen} from "../../icon/Icon";
import {FlexRow, ModalTitleContent} from "../../components/ui/Content";
import {useOnClickOutside} from "../../hooks/useClickOutside";

export interface ModalProps {
    title: string
    content: () => JSX.Element | React.ReactElement
    onEdit: () => void
    onGoBack: () => void
}

let initMenu: HTMLDivElement;

export const InfoModal = ({
                              title,
                              content,
                              onEdit,
                              onGoBack
                          }: ModalProps) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef(initMenu);
    useOnClickOutside(menuRef, () => setIsMenuOpen(false))
    return <>
        {isMenuOpen &&
            <>
                <MobileBackground/>
                <ProfileModalsEditMenu style={{height: '48px'}}>
                    <FlexRow style={{cursor: 'pointer'}} ref={menuRef} onClick={onEdit}>
                        <EditPen/>
                        <Body1Pointer>
                            Редактировать
                        </Body1Pointer>
                    </FlexRow>
                </ProfileModalsEditMenu>
            </>
        }
        <ModalContent>
            <InfoModalHeader>
                <ModalTitleContent>
                    <BackArrow className={'modalIcon'} onClick={onGoBack}/>
                    <Title>
                        {title}
                    </Title>
                </ModalTitleContent>
                <Body1PointerLink className={'modalDots'} onClick={() => setIsMenuOpen(prev => !prev)}>
                    <Dots/>
                </Body1PointerLink>
            </InfoModalHeader>
            {content && <ModalBody>
                {content()}
            </ModalBody>}
            <ModalFooter/>
        </ModalContent></>
}
